import GameProtocolSidePanel from './GameProtocolSidePanel';

export default GameProtocolSidePanel;
